<div class="legal-shell" style="display:flex;gap:24px">
  <nav class="legal-sidebar" style="min-width:220px">
    <ul>
      <li *ngFor="let s of sections" [class.selected]="s.key === activeSection" style="margin-bottom:10px">
        <a (click)="navigateTo(s.key)" [class.selected]="s.key === activeSection" style="cursor:pointer;">
          {{ s.translationKey | translate }}
        </a>
      </li>
    </ul>
  </nav>

  <main style="flex:1">
    <router-outlet></router-outlet>
  </main>
</div>
